/**
 * Norwegian Price Space Formatting
 * Converts dot separators to space separators in Norwegian currency
 * Example: "2.500 NOK" → "2 500 NOK"
 */

(function() {
  'use strict';

  // Check if Norwegian currency/locale is active
  function isNorwegianActive() {
    // Check multiple methods to detect Norwegian currency
    const checks = [
      // Check theme currency data
      window.theme && window.theme.moneyFormat && window.theme.moneyFormat.includes('NOK'),
      // Check existing prices on page
      document.querySelector('[data-product-price], .price, .new-price, .old-price')?.textContent?.includes('NOK'),
      // Check URL for Norwegian indicators
      window.location.href.toLowerCase().includes('/no/') ||
      window.location.href.toLowerCase().includes('norway'),
      // Check document language
      document.documentElement.lang === 'no'
    ];

    return checks.some(check => check);
  }

  // Replace dots with spaces in price strings
  function replaceDotsWithSpaces(priceString) {
    if (!priceString || typeof priceString !== 'string') return priceString;

    // Only process if it contains NOK
    if (!priceString.includes('NOK')) return priceString;

    // Replace digit.digits patterns with digit spaces (for thousands separator)
    // This regex ensures we only replace dots that are thousand separators, not decimals
    return priceString.replace(/(\d)\.(\d{3})/g, '$1 $2');
  }

  // Override Shopify money formatting functions
  function overrideMoneyFormatting() {
    if (!isNorwegianActive()) return;

    // Override Shopify.formatMoney
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      const originalShopifyFormat = window.Shopify.formatMoney;

      window.Shopify.formatMoney = function(cents, format) {
        const result = originalShopifyFormat.call(this, cents, format);
        return replaceDotsWithSpaces(result);
      };
    }

    // Override theme currency functions
    if (window.theme && window.theme.Currency && typeof window.theme.Currency.formatMoney === 'function') {
      const originalThemeFormat = window.theme.Currency.formatMoney;

      window.theme.Currency.formatMoney = function(cents, format) {
        const result = originalThemeFormat.call(this, cents, format);
        return replaceDotsWithSpaces(result);
      };
    }

    // Override themeCurrency functions
    if (window.themeCurrency && typeof window.themeCurrency.formatMoney === 'function') {
      const originalThemeCurrencyFormat = window.themeCurrency.formatMoney;

      window.themeCurrency.formatMoney = function(cents, format) {
        const result = originalThemeCurrencyFormat.call(this, cents, format);
        return replaceDotsWithSpaces(result);
      };
    }

    console.log('Norwegian price space formatting activated');
  }

  // Process existing prices on the page
  function processExistingPrices() {
    if (!isNorwegianActive()) return;

    const priceSelectors = [
      '[data-product-price]',
      '[data-cart-total]',
      '.price',
      '.new-price',
      '.old-price',
      '.product__price',
      '.cart__total__price'
    ];

    priceSelectors.forEach(selector => {
      const elements = document.querySelectorAll(selector);
      elements.forEach(el => {
        if (el.textContent && el.textContent.includes('NOK')) {
          el.textContent = replaceDotsWithSpaces(el.textContent);
        }
      });
    });
  }

  // Initialize the formatting
  function init() {
    overrideMoneyFormatting();

    // Process existing prices after a short delay to ensure page is loaded
    setTimeout(processExistingPrices, 100);

    // Re-run formatting after theme scripts potentially load
    setTimeout(overrideMoneyFormatting, 500);
    setTimeout(overrideMoneyFormatting, 1000);
  }

  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Also run on window load
  window.addEventListener('load', function() {
    setTimeout(init, 100);
  });

})();
